import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PlotsSelectionMenuEntry from './PlotsSelectionMenuEntry';
import SitePlanVisibleType from '../enums/SitePlanVisibleType';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import GenericWindow from '../window/GenericWindow';
import IconButtonNonReact from '../components/IconButtonNonReact';
import WindowType from '../enums/WindowType';
import ResizeWatchers from '../ui_core/ResizeWatchers';
import Urls from '../urls/Urls';
import AssetsManager from '../assets_management/AssetsManager';
import FiltersButtons  from './FiltersButtons';
import './PlotsSelectionMenu.css';
export default class PlotsSelectionMenu {
	constructor({showPlotDetailedInformation,
			showPlotMenuForPlot, showMenu, showStreetView,
			clearFilters, getSitePlanVisibleType,
			getConfiguration, clickShowForSale,
			iMenuManager }){
		const title = 'Plots';
		this._window = new GenericWindow({tooltipMessage:title, name:title, minWidth:100, maxWidth:800, minHeight:100, maxHeight:1000,
			defaultWidth:600, defaultHeight:600, defaultX:10, defaultY:10, minimized:true, maximized:false, minimizable:true,
			maximizable:true, closeable:true, minimizeOnClose:true, resizable:true, dragable:true,
			type:WindowType.PLOTS_SELECTION_MENU
		});
		this._getConfiguration = getConfiguration;
		this._showPlotDetailedInformation = showPlotDetailedInformation;
		this._showPlotMenuForPlot = showPlotMenuForPlot;
		this._showStreetView = showStreetView;
		this._getSitePlanVisibleType= getSitePlanVisibleType;
		this._element = this._window.getElement();
		this._element.classList.add('plots-menu');
		this._innerElement =this._window.getMainElement();
		this._innerElement.classList.add('inner');
		this._buttonDoneElement =document.createElement('button-done');
		this._createEntries = this._createEntries.bind(this);
		this._callbackClickedEntry = this._callbackClickedEntry.bind(this);
		this.show = this.show.bind(this);
		this.hide = this.hide.bind(this);
		this._done = this._done.bind(this);
		this._addEntry = this._addEntry.bind(this);
		this._removeEntry = this._removeEntry.bind(this);
		this.initialize = this.initialize.bind(this);
		this._onResize = this._onResize.bind(this);
		this._setColumnsClass = this._setColumnsClass.bind(this);
		this._entries = [];
		this._menuElement= document.createElement('div');
		this._menuElement.classList.add('top-menu');
		this._iconButtonMenu = new IconButtonNonReact({ 	
				className:"button-menu", 
				imgUrl:Urls.assets+'icons/UI_Button_Filter.png',
				onClick:showMenu
		});
		this._menuElement.appendChild(this._iconButtonMenu.element);
		this._scrollableElement = document.createElement('div');
		this._scrollableElement.classList.add('scrollable');
		this._innerElement.appendChild(this._menuElement);
		this._innerElement.appendChild(this._scrollableElement);
		this._clickedOffManager = new ClickedOffManager({elementRef:this._element, hide:this.hide});
		ResizeWatchers.add({element:this._element, onResized:this._onResize});
		this._filtersButtonsWrapperElement = document.createElement('div');
		this._filtersButtonsWrapperElement.classList.add('filter-buttons-wrapper');
		this._menuElement.appendChild(this._filtersButtonsWrapperElement);
		const filtersButtonsFactory = React.createFactory(FiltersButtons);
		ReactDOM.render(filtersButtonsFactory(
		{ 
			singleRow:true,
			clickClear:clearFilters, clickShowForSale, 
			getConfiguration, iMenuManager
		}),
		this._filtersButtonsWrapperElement);
	}
	show(){
		this._window.unminimize();
		this._window.bringToFront();
	}
	get element(){
		return this._element;
	}
	hide(){
		this._window.minimize();
	}
	setFilteredPlots(filteredSiteJsonUnitPlots){
		const mapPlotNumberToEntry = new Map();
		this._entries.forEach(entry=>
			mapPlotNumberToEntry.set(entry.number, entry));
		filteredSiteJsonUnitPlots.forEach(filteredSiteJsonUnitPlot=>
		{
			const entry = mapPlotNumberToEntry.get(filteredSiteJsonUnitPlot.number);
			if(!entry)return;
			mapPlotNumberToEntry.delete(filteredSiteJsonUnitPlot.number);
			entry.filteredOut = false;
		});
		const entriesToBeFilteredOut = Array.from(mapPlotNumberToEntry.values());
		entriesToBeFilteredOut.forEach(entry=>entry.filteredOut = true);
	}
	_onResize(){
		if(this._scrollableElement.offsetWidth<500){
			this._setColumnsClass('one-columns');
			return;
		}
		if(this._scrollableElement.offsetWidth<1000){
			this._setColumnsClass('two-columns');
			return;
		}
		if(this._scrollableElement.offsetWidth<1500){
			this._setColumnsClass('three-columns');
			return;
		}
		this._setColumnsClass('four-columns');
	}
	_callbackClickedEntry(siteJsonUnitPlot){
		if(this._getSitePlanVisibleType()===SitePlanVisibleType.OUTSIDE_360){
			this._showStreetView({nearPlot:siteJsonUnitPlot});
			this.hide();
			return;
		}
		if(this._getConfiguration().onClickPlotSelectionMenuEntryShowDetailedElseSmallPlotInfo)
			this._showPlotDetailedInformation(siteJsonUnitPlot);
		else
			this._showPlotMenuForPlot(siteJsonUnitPlot, /*zoomOut*/true);
		this.hide();
	}
	_setColumnsClass(className){
		if(this._currentColumnClassName)
			this._element.classList.remove(this._currentColumnClassName);
		this._element.classList.add(className);
		this._currentColumnClassName = className;
	}
	_done(){
		const selectedSiteJsonUnitPlots = this._entries.filter(entry=>entry.selected).map(entry=>entry.siteJsonUnitPlot);
		this._callbackPicked(selectedSiteJsonUnitPlots);
		this.hide();
	}
	initialize({siteJson}){
		this._siteJson= siteJson;
		this._createEntries();
	}
	_createEntries(){
		const siteJsonUnitPlots = this._siteJson.getPlotsArray();
		siteJsonUnitPlots.sort(function(a, b) {
			return a.number - b.number;
		});
		siteJsonUnitPlots.forEach(siteJsonUnitPlot=>{
			const entry = new PlotsSelectionMenuEntry({
				callbackClicked:this._callbackClickedEntry,
				siteJsonUnitPlot:siteJsonUnitPlot,
				configuration:this._getConfiguration()
			});
			this._addEntry(entry);
		});
	}
	_addEntry(entry){
		this._entries.push(entry);
		this._scrollableElement.appendChild(entry.element);
	}
	_removeEntry(entry){
		this._entries.splice(this._entries.indexOf(entry), 1);
		this._scrollableElement.removeChild(entry.element);
	}
}
